import request from '@/utils/request'

let Exchange_logApi = {

  /*兑换记录列表*/
  list(data) {
    return request._post('/shop/plus.exchange_log.Index/index', data);
},
  receive(data) {
    return request._post('/shop/plus.exchange_log.Index/receive', data);
},
/*添加兑换记录*/
add(data) {
    return request._post('/shop/plus.exchange_log.Index/add', data);
},
/*修改兑换记录*/
edit(data) {
    return request._post('/shop/plus.exchange_log.Index/edit', data);
},
/*删除兑换记录*/
del(data) {
    return request._post('/shop/plus.exchange_log.Index/del', data);
},
/*兑换记录详情*/
detail(data) {
  return request._post('/shop/plus.exchange_log.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.exchange_log.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.exchange_log.Setting/getSetting', data, errorback);
    },
}
export default Exchange_logApi;



// WEBPACK FOOTER //
// ./src/api/exchange_log.js